import { QueryClient, defaultShouldDehydrateQuery } from '@tanstack/react-query';
import { persistQueryClient } from '@tanstack/react-query-persist-client';
import storage from '../../../hooks/useStorage/useStorage';
import { offlineQueryClientIDBPersister } from './utils/offlineQueryClientIDBPersister';

const QUERY_KEY_TO_PERSIST = 'should-persist-to-offline';

const offlineQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      enabled: false,
      gcTime: Infinity,
      staleTime: Infinity,
      networkMode: 'offlineFirst',
    },
  },
});

const persistOfflineQueryClient = () =>
  persistQueryClient({
    maxAge: Infinity,
    queryClient: offlineQueryClient,
    persister: offlineQueryClientIDBPersister,
    dehydrateOptions: {
      shouldDehydrateMutation: () => false,
      shouldDehydrateQuery: (query) =>
        defaultShouldDehydrateQuery(query) &&
        query.queryKey.includes(QUERY_KEY_TO_PERSIST) &&
        !!storage.getTeamId() &&
        !!query.queryKey.includes(storage.getTeamId()),
    },
  });

const restartOfflineQueryClientToNewTeam = () => {
  offlineQueryClient.unmount();
  const [unsubscribe] = persistOfflineQueryClient();
  return unsubscribe;
};

const [internalUnsubscribeFirstOfflineDataRestore, isFirstOfflineDataRestoring] =
  persistOfflineQueryClient();

const unsubscribeFirstOfflineDataRestore = () => {
  offlineQueryClient.unmount();
  internalUnsubscribeFirstOfflineDataRestore();
};

export {
  QUERY_KEY_TO_PERSIST,
  isFirstOfflineDataRestoring,
  offlineQueryClient,
  restartOfflineQueryClientToNewTeam,
  unsubscribeFirstOfflineDataRestore,
};
